import axios from "axios";

const baseUrl: string = process.env.REACT_APP_METRIC_API_URL ?? "";

export const getMetrics = async (userToken: string) => {
    const url = `${baseUrl}/dashboards/platform`;

    const response = await axios.get(url, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: userToken,
        },
    });

    return response.data;
};
